import { render } from "./productIntoWarehouse.vue?vue&type=template&id=39aab5a0&scoped=true"
import script from "./productIntoWarehouse.vue?vue&type=script&lang=js"
export * from "./productIntoWarehouse.vue?vue&type=script&lang=js"

import "./productIntoWarehouse.vue?vue&type=style&index=0&id=39aab5a0&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39aab5a0"]])

export default __exports__